module.exports = __webpack_public_path__ + "img/com-icon.357e2511.svg";